<template>
  <h3 v-if="getTheCart.family_discount_amount" class="text-body-1"
    >Family Discount ({{ getTheCart.family_discount_pcnt_formatted }}) : -${{
      amountInUSDFormatted
    }}</h3
  >
</template>

<script>
import { mapGetters } from 'vuex'
import roundToFixed from '@/utils/roundToFixed'

export default {
  name: 'CartFamilyDiscount',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getTheCart']),
    amountInUSDFormatted() {
      return roundToFixed(this.getTheCart.family_discount_amount_usd)
    },
  },
}
</script>
